export const SELLER_CHANNEL_SUBSCRIBE_SUCCESS = 'SELLER_CHANNEL_SUBSCRIBE_SUCCESS';
export const subscribeToSellerChannelSuccess = (sellerChannelInfo) => ({
  type: SELLER_CHANNEL_SUBSCRIBE_SUCCESS,
  sellerChannelInfo,
});

export const SELLER_CHANNEL_SUBSCRIBE_FAILURE = 'SELLER_CHANNEL_SUBSCRIBE_FAILURE';
export const subscribeToSellerChannelFailure = (pusherError) => ({
  type: SELLER_CHANNEL_SUBSCRIBE_FAILURE,
  pusherError,
});
